module.exports = __webpack_public_path__ + "7e072a845d0b355d96889c450bac2c05.png";